const backofficeEN = {
  bo: {
    payments: {
      title: 'Payments',
      field_labels: {
        merchant_xref_id: 'Merchant ID',
      },
      gateway: 'Payment Gateway',
      state: 'Status',
      state_reason_text: 'Status Reason',
      state_text: {
        data_collection: 'Data Collection',
        adjudication: 'Adjudication',
        accepted: 'Accepted',
        rejected: 'Rejected',
        blocked: 'Blocked',
        terminated: 'Terminated',
        payout_created: 'Payout Created',
        unknown: 'Unknown State',
      },
      state_reason_explanations: {
        fraud: 'The merchant was closed for fraud.',
        additional_documents_required:
          'The merchant needs to upload some additional documents to get verified.',
        high_risk_cb_rate: 'The account was closed due to high risk or high rate of chargebacks.',
        reported_user: 'The merchant was reported as fraudulent.',
        tos_violation: 'The merchant is operating against Terms of Service',
        country_not_supported:
          'The merchant is trying to KYC in a country other than US or Canada.',
        compliance: 'The risk team closed the account due to compliance reasons.',
        unsupported: 'Unsupported',
        closed_for_loss:
          "The merchant's account has maintained a negative balance for more than the allowed number of days.",
        account_closed:
          'Account was closed by payment processor. Reach out to processor for further information.',
        unknown: 'Unknown',
      },
      service: {
        wepay_cp: 'WePay Card Present',
        wepay_cnp: 'WePay Card Not Present',
        payrix_cp: 'Payrix Card Present',
        payrix_cnp: 'Payrix Card Not Present',
        worldpay_cp: 'Worldpay Card Present',
        worldpay_cnp: 'Worldpay Card Not Present',
        moneris_go_cp: 'Moneris Go Card Present',
        payrix_pax_cp: 'Payrix Pax Card Present',
        chase_pax_cp: 'Chase Pax Card Present',
        tsys_pax_cp: 'TSYS Pax Card Present',
      },
      settings: {
        title: 'Payment Settings',
        not_available_message: 'Payment settings not available for this venue.',
        agent: {
          email: 'TouchBistro Email',
          helper_text: 'Enter your email to confirm you want to make this change',
        },
        express: {
          account_id: 'Account ID',
          account_token: 'Account Token',
          acceptor_id: 'Acceptor ID',
          default_terminal_id: 'Default Terminal ID',
        },
        update: {
          title: 'Update Credentials',
          mid_title: 'Update MID',
          submit: 'Update',
          unchanged: 'Credentials have not been altered',
          success: 'Successfully updated the merchant credentials',
        },
        accept: {
          button: 'Accept',
          title: 'Accept Payment Service',
          reason: 'Reason',
          success: 'Payment settings accepted successfully',
          error: 'Failed to accept payment settings',
          reason_placeholder: 'Please specify reason for manual accept',
          max_chars: 'Maximum {{max}} characters',
        },
        confirm: {
          title: 'Hold Up',
          message:
            'You are making a change to critical merchant information. Please verify all values before saving.',
        },
        validation_error: {
          form_error: 'Please fill in all required fields correctly',
          required: 'This field is required',
          email_match: "Email doesn't match",
          merchant_xref_id: "This doesn't look like a valid Merchant ID",
          account_id: "This doesn't look like a valid Account ID",
          account_token: "This doesn't look like a valid Account Token",
          acceptor_id: "This doesn't look like a valid Acceptor ID",
        },
      },
      validation_errors: {
        field_max_length: 'Must be no more than {{max_length}} alphanumeric characters long',
        field_max_length_numbers: 'Must be no more than {{max_length}} numbers long',
        field_length_min_max:
          'Must be between {{min_length}} and {{max_length}} alphanumeric characters long',
        field_length_min_max_numbers:
          'Must be between {{min_length}} and {{max_length}} numbers long',
        field_length: 'Must be exactly {{length}} alphanumeric characters long',
        field_length_numbers: 'Must be exactly {{length}} numbers long',
      },
      terminals: {
        title: 'Payment Terminals',
        new_title: 'Add Payment Terminal',
        edit_title: 'Edit Payment Terminal',
        var_sheet_details: 'Var Sheet Details',
        add: 'Add Terminal',
        details: 'Terminal Details',
        empty_helper: 'Set up a terminal to begin accepting payments from your guests.',
        back_button: 'Back to Payment Terminals',
        unsupported_gateway: 'Unsupported Payment Gateway',
        unsupported_merchant_operation: 'Operation not allowed, please contact support.',
        linked_to_venue: 'Linked to Venue',
        linked_to_venue_true: 'Linked',
        linked_to_venue_false: 'Not Linked',
        assigned: 'Assigned',
        mode_display: {
          PAY_AT_COUNTER: 'Pay at counter',
          PAY_AT_TABLE: 'TouchBistro Pay at Table',
          ORDER_AND_PAY_AT_TABLE: 'TouchBistro One',
        },
        validation: {
          unique: {
            label: 'A terminal with this name already exists. Enter a different name.',
            xrefid: 'Enter a unique terminal ID that does not contain special characters.',
            processor_terminal_id: 'Enter a unique ID.',
            serial_number: 'Enter a unique serial number',
            ip_address: 'Enter a unique valid ip address',
          },
          invalid_port: 'Enter a valid port number',
          invalid_ip_address: 'Enter a valid IP address (e.g., 192.168.1.1)',
        },
        moneris_go: {
          field_labels: {
            label: 'Terminal Name',
            xrefid: 'Terminal ID',
            model: 'Terminal Model',
            serial_number: 'Serial Number',
          },
          helper_text: {
            label: 'Your terminal name will be displayed on your connected products.',
            xrefid: 'The unique ID assigned by your Payment Provider.',
            model: 'The model name of the terminal.',
            serial_number: "Required for TouchBistro One & TouchBistro's Pay-at-Table solution",
          },
        },
        chase_pax: {
          field_labels: {
            label: 'Terminal Name',
            xrefid: 'Terminal ID',
            model: 'Terminal Model',
            serial_number: 'Serial Number',
            ip_address: 'IP Address',
            port: 'Port',
            processor_terminal_id: 'Chase Terminal ID',
          },
          helper_text: {
            label: 'Your terminal name will be displayed on your connected products.',
            model: 'The model name of the terminal.',
            serial_number:
              'The 10-digit serial number found on the terminal sticker on the back of the device.',
            ip_address:
              'Enter the IP Address shown on your terminal under Network Details > IP Address.',
            port: 'Port',
            xrefid: 'This ID is automatically assigned by PAX.',
            processor_terminal_id: 'This 3-digit number is found on the VAR sheet.',
          },
        },
        payrix_pax: {
          field_labels: {
            label: 'Terminal Name',
            xrefid: 'Terminal ID',
            model: 'Terminal Model',
            serial_number: 'Serial Number',
            ip_address: 'IP Address',
            port: 'Port',
            processor_terminal_id: 'Assigned Payrix TID',
          },
          helper_text: {
            label: 'Your terminal name will be displayed on your connected products.',
            model: 'The model name of the terminal.',
            serial_number:
              'The 10-digit serial number found on the terminal sticker on the back of the device.',
            ip_address: 'Enter the IP Address shown on the idle screen of the Vanitv app.',
            port: 'The port number will always be 10009.',
            xrefid: 'This ID is automatically assigned by PAX.',
            processor_terminal_id: 'The 3-digit Terminal ID from the VAR Sheet.',
          },
        },
        tsys_pax: {
          field_labels: {
            label: 'Terminal Name',
            model: 'Terminal Model',
            serial_number: 'Serial Number',
            xrefid: 'Terminal ID',
            processor_auth_code: 'Gen2 Auth Code',
            processor_terminal_id: 'Terminal ID Number',
            processor_terminal_number: 'Terminal Number',
            store_number: 'Store Number',
            ip_address: 'IP Address',
            port: 'Port',
          },
          helper_text: {
            label: 'Your terminal name will be displayed on your connected products.',
            model: 'The model name of the terminal.',
            serial_number:
              'The 10-digit serial number found on the terminal sticker on the back of the device.',
            ip_address: 'Enter the IP Address shown on the idle screen of the TSYS Sierra app.',
            port: 'The port number will always be 10009.',
            xrefid: 'This ID is automatically assigned by PAX.',
            processor_terminal_id:
              'The 8-digit Terminal ID Number from the VAR Sheet. You must change the V to a 7 when entering the value on this page.',
            processor_terminal_number: 'The 4-digit Terminal Number from the VAR Sheet.',
            store_number: 'The 4-digit Store Number from the VAR Sheet.',
            processor_auth_code: 'This code can be found on the VAR sheet.',
          },
        },
        delete: {
          confirm: 'Are you sure you want to delete the following terminals:',
          confirm_caption: 'This action cannot be undone',
          button_cta: 'Delete',
          success: 'Terminal{{plural}} successfully deleted',
          failure: 'Terminal{{plural}} failed to delete. Please try again',
        },
        link: {
          title: 'Link Device',
          code: 'Device Code',
          description: 'Use this code to link a device to your restaurant in TouchBistro Cloud.',
          label: 'Enter the following code on your device',
          expiry: 'This code will expire in',
          refresh: 'Refresh',
          serial_number_required: 'Add serial number to link',
        },
        mode: {
          title: 'Device Setup',
          subtitle: 'Determine how this device will be used in your venue',
          pay_at_counter: 'Pay at counter',
          pay_at_counter_description:
            'Use this terminal to accept payments at the counter, while a separate POS handles orders.',
          pay_at_table: 'TouchBistro Pay at Table',
          pay_at_table_description:
            'Use this terminal to accept payments at the table, while a separate POS handles orders.',
          touchbistro_one: 'TouchBistro One ({{available}} of {{total}} licenses available)',
          touchbistro_one_no_licenses: 'TouchBistro One (0 licenses available)',
          touchbistro_one_description:
            'Use this terminal as a POS that takes both orders and payments at the table.',
        },
        unlink: {
          confirm:
            "Are you sure you want to unlink {{terminalName}}?\n\nUnlinking this terminal will close the app. To use it again, you'll need to set it up.",
          button_cta: 'Unlink Device',
          success: '{{terminalName}} is no longer linked to the venue',
          failure: 'Failed to unlink. Please try again',
          support_message: 'To unlink this device, please contact <1>TouchBistro Support</1>.',
        },
        models: {
          payrix: {
            lane3000: 'TouchBistro Payments Ingenico Lane/3000',
            link2500: 'TouchBistro Payments Ingenico Link/2500',
          },
          moneris: {
            dx8000: 'Moneris Go Terminal (Black) - Dx8000',
            ex8000: 'Moneris Go Slim (EX8000)',
            victa: 'Moneris Go Terminal (White) - Victa',
            a35: 'Moneris Go Pin Pad (A35)',
          },
          chase_pax: {
            a920Pro: 'TouchBistro Payments A920 Pro',
            a920Max: 'TouchBistro Payments A920 Max',
            a800: 'TouchBistro Payments A800',
            a6630: 'TouchBistro Payments A6630',
          },
          payrix_pax: {
            a920Pro: 'TouchBistro Payments A920 Pro',
            a920Max: 'TouchBistro Payments A920 Max',
            a800: 'TouchBistro Payments A800',
            a35: 'TouchBistro Payments A35',
          },
          tsys_pax: {
            a920Pro: 'TSYS - PAX A920 Pro',
            a920Max: 'TSYS - PAX A920 Max',
            a800: 'TSYS - PAX A800',
          },
        },
        missing_credentials_dialog: {
          title: 'Payment Credentials Required',
          message: 'Enter your payment credentials before proceeding with this step.',
          cta: 'Go to Payment Credentials',
        },
        missing_credentials_dialog_non_admin: {
          title: 'Payment Credentials Required',
          message_1: 'Payment credentials must be entered before terminals can accept payments.',
          message_2: 'You don’t have access to Payment Credentials. ',
          message_3: 'Please contact an admin for assistance.',
          cta: 'Okay',
        },
        device_setup: {
          header: 'Device Setup',
          description: 'Determine how this device will be used in your venue',
          pay_at_counter: {
            label: 'Pay at counter',
            description:
              "Select if you'll be using a separate countertop POS Device and want this terminal to accept payments",
          },
          pay_at_table: {
            label: 'Pay at table',
            description:
              "Select if you'll be using a separate POS Device and want this terminal to accept payments at table",
          },
          order_and_pay_at_table: {
            label: 'Pay & Order at table',
            description:
              'Select if you want this terminal to operate as a POS, taking orders and payments at table',
          },
        },
      },
      credentials: {
        title: 'Payment Credentials',
        header: 'In-Venue Payments',
        update: {
          success: 'Payment Credentials have been saved!',
          error: 'Failed to save Payment Credentials.',
        },
        confirmation: {
          title:
            'When changing payment credentials any incorrect information will impact in-venue payment operations.',
          message: 'Are you sure you want to make these changes?',
          confirm: 'Yes, Save Changes',
          cancel: 'No, Return to Payment Credentials',
        },
        agent: {
          warning: 'Payment Credentials can only be edited by the venue.',
        },
        unsupported_gateway: 'Unsupported Payment Gateway',
        gateway_helper_text: 'This is who you are contracted to use for in-venue payments.',
        validation: {
          unique: {
            merchant_xref_id: 'Enter a unique Merchant ID',
          },
        },
        moneris_go: {
          field_labels: {
            merchant_xref_id: 'Moneris Merchant ID',
            token: 'API Token',
            store_id: 'Store ID',
          },
          helper_text: {
            merchant_xref_id: 'This 13-digit ID is found in your Welcome Email from Moneris.',
            token:
              'This 20-character token is found in the <0>Moneris Go Portal</0> under Settings > Developer Tools.',
            store_id: 'This 10-character ID is found in your Welcome Email from Moneris.',
          },
        },
        chase_pax: {
          field_labels: {
            merchant_xref_id: 'PNS Merchant Number',
            pax_merchant_id: 'PAX Merchant ID',
            username: 'Username',
            // deepcode ignore NoHardcodedPasswords: Translation key, not hardcoded password
            password: 'Password',
          },
          helper_text: {
            merchant_xref_id: 'This 12-digit number is found on the VAR sheet.',
            pax_merchant_id: 'This ID is automatically assigned by PAX after account creation.',
            username:
              'Sent by Chase via encrypted email. Case-sensitive – enter exactly as provided.',
            // deepcode ignore NoHardcodedPasswords: Translation key, not hardcoded password
            password:
              'Sent by Chase via encrypted email. Case-sensitive – enter exactly as provided.',
          },
        },
        payrix_pax: {
          field_labels: {
            merchant_xref_id: 'Payrix Merchant ID',
            pax_merchant_id: 'PAX Merchant ID',
            merchant_number: 'Payrix Payment Merchant Number',
          },
          helper_text: {
            merchant_xref_id: 'Payrix Merchant ID (e.g. p1_mer_1234567)',
            pax_merchant_id: 'PAX Merchant ID',
            merchant_number: 'Payrix Payment MID from the Var Sheet',
          },
        },
        tsys_pax: {
          warning_message_agent:
            "Note: Ensure these fields match what is on the VAR sheet exactly. Any errors will impact the venue's ability to accept payments.",
          field_labels: {
            merchant_xref_id: 'Merchant Number',
            merchant_name: 'Merchant Name',
            merchant_city: 'Merchant City',
            merchant_state: 'Merchant State',
            merchant_postal_code: 'Merchant Postal Code',
            merchant_category_code: 'Merchant Category Code (MCC)',
            bank_identification_number: 'Bank Identification Number',
            agent_chain_number: 'Agent Chain Number',
            agent_bank_number: 'Agent Bank Number',
            pax_merchant_id: 'PAX Merchant ID',
          },
          helper_text: {
            merchant_xref_id: 'The 12-digit Merchant Number from the VAR Sheet.',
            merchant_name:
              'The merchant name from the VAR Sheet. Must match VAR Sheet exactly (including any capitalization, symbols, or spacing).',
            merchant_city: 'The merchant city from the VAR Sheet.',
            merchant_state: 'The 2-character merchant state abbreviation from the VAR Sheet.',
            merchant_postal_code: 'The merchant postal code from the VAR Sheet.',
            merchant_category_code: 'The 4-digit MCC code from the VAR Sheet.',
            bank_identification_number: 'The 6-digit Bank ID from the VAR Sheet.',
            agent_chain_number: 'The 6-digit Agent Chain Number from the VAR Sheet.',
            agent_bank_number: 'The 6-digit Agent Bank Number from the VAR Sheet.',
            pax_merchant_id: 'This ID is automatically assigned by PAX after account creation.',
          },
        },
      },
    },
  },
}

export default backofficeEN
